import { render, staticRenderFns } from "./PerformanceStatusComponent.vue?vue&type=template&id=94a530ec&scoped=true&"
import script from "./PerformanceStatusComponent.vue?vue&type=script&lang=js&"
export * from "./PerformanceStatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceStatusComponent.vue?vue&type=style&index=0&id=94a530ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a530ec",
  null
  
)

export default component.exports